import { useCookies } from 'react-cookie';

import { COOKIE_BETA } from '@src/config/constants';

/**
 * @name useBetaFlag
 * @description Hook to check if the beta flag is set and redirect otherwise.
 */
export const useBetaFlag = (): boolean => {
  // Hooks
  const [cookies] = useCookies();

  // Setup
  const isBeta = cookies[COOKIE_BETA];

  return isBeta;
};
